export default __webpack_public_path__ + "static/media/cases5@2x.d5e7d588.jpg";